import { Component, Input, OnInit } from '@angular/core';
import { transferAmountSummaryTemplate } from '@finxone-platform/shared/default-templates';
import Handlebars from 'handlebars';
import { SafeHtmlPipe } from '../../../../lib/pipes/SafeHtml.pipe';

@Component({
  selector: 'finxone-web-frontend-amount-summary',
  templateUrl: './amount-summary.component.html',
  styleUrls: ['./amount-summary.component.scss'],
  imports: [SafeHtmlPipe],
})
export class AmountSummaryComponent implements OnInit {
  @Input() currency = '';
  @Input() amount = 0;
  @Input() template = transferAmountSummaryTemplate;
  private handlebarTemplate: HandlebarsTemplateDelegate<any>;

  ngOnInit() {
    this.handlebarTemplate = Handlebars.compile(this.template);
  }

  public renderContent(amount: number): string {
    const result = this.handlebarTemplate({
      amount: amount,
      currency: this.currency,
    });
    return result;
  }
}
